import { useAppSelector } from "@app/hooks";
import {
  selectLandCoverChange,
  selectLandCoverChangeStatus,
  selectLandCoverChangeError,
} from "@app/features/msa/msaSlice";

/**
 * Pure reader hook for Land Cover Change data.
 * All calculation logic lives in useLandCoverChangeAutoTrigger (mounted in App.tsx).
 * This hook is navigation-safe: it only reads from Redux and never triggers side effects.
 */
export function useLandCoverChange(projectId?: string) {
  const landCoverChange = useAppSelector((state) =>
    projectId ? selectLandCoverChange(state, projectId) : null
  );
  const status = useAppSelector((state) =>
    projectId ? selectLandCoverChangeStatus(state, projectId) : "idle"
  );
  const error = useAppSelector((state) =>
    projectId ? selectLandCoverChangeError(state, projectId) : null
  );

  return {
    projectAreaHa: landCoverChange?.projectAreaHa ?? null,
    lucAreaHa: landCoverChange?.lucAreaHa ?? null,
    isLoading: status === "calculating",
    error: error ?? null,
  };
}
